import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
// import {Row, Col, Image} from 'react-bootstrap';
import { css } from "styled-components/macro"; //eslint-disable-line
import { SectionHeading, Subheading as SubheadingBase } from "components/misc/Headings.js";
import { SectionDescription } from "components/misc/Typography.js";

import DjangoIcon from "../../images/tech_stack/django-icon.png";
import ReactIcon from "../../images/tech_stack/react-icon.png";
import PipelineIcon from "../../images/tech_stack/pipeline-icon.svg";
import PythonIcon from "../../images/tech_stack/python-icon.png";
import SGIcon from "../../images/tech_stack/sg-icon.png";
import APIIcon from "../../images/tech_stack/api-icon.png";
import ECommerceIcon from "../../images/tech_stack/ecommerce-icon.png";

import AutodeskIcon from "../../images/tech_stack/autodesk-icon.png";

import defaultCardImage from "../../images/shield-icon.svg";

const Container = tw.div`relative -mx-8 px-8 bg-gray-800 text-gray-100`;

const ThreeColumnContainer = styled.div`
  ${tw`flex flex-col items-center md:items-stretch md:flex-row flex-wrap md:justify-center max-w-screen-lg mx-auto py-20 md:py-24 `}
`;

const Subheading = tw(SubheadingBase)`mb-4`;
const Heading = tw(SectionHeading)`w-full`;
const Description = tw(SectionDescription)`w-full text-center text-gray-200`;

const VerticalSpacer = tw.div`mt-10 w-full`

const Column = styled.div`
  ${tw`md:w-1/2 lg:w-1/3 max-w-sm`}
`;

const Card = styled.div`
  ${tw`flex flex-col bg-gray-200 sm:flex-row items-center sm:items-start text-center sm:text-left h-128 mx-2 my-2 px-2 py-4 rounded-lg shadow-lg `}
  .imageContainer {
    ${tw`border text-center rounded-full p-5 flex-shrink-0 `}
    img {
      ${tw`w-6 h-6`}
    }
  }

  .textContainer {
    ${tw`sm:mx-4 sm:my-4 w-full`}
  }

  .title {
    ${tw`mt-4 tracking-wide font-bold text-2xl text-black leading-none`}
  }

  .description {
    ${tw`mt-1 sm:mt-4 font-medium text-gray-700 leading-loose`}
  }
`;

const CardType = tw.div`font-semibold text-sm text-gray-500 `;

export default ({ cards = null, 
  heading = (
  <>
  Our <span tw="text-primary-500">Tech</span> Stack
</>  ),
  subheading = "What we work with:", 
  description = "Here are some of the technologies/platforms we use & have worked with." }) => {
  /*
   * This componets has an array of object denoting the cards defined below. Each object in the cards array can have the key (Change it according to your need, you can also add more objects to have more cards in this feature component) or you can directly pass this using the cards prop:
   *  1) title - the title of the card
   *  2) description - the description of the card
   *  If a key for a particular card is not provided, a default value is used
   */

  const defaultCards = [
    {
      image: DjangoIcon,
      title: "Django",
      type: "Web Application Platform",
      description: "Python based Web Framework that encourages rapid development and clean, pragmatic design. Django is WebAppDev's primary resource when building solid, secure backend services."
    },
    { 
      image: PythonIcon,
      title: "Python",
      type: "Programming",      
      description: "Python is an interpreted, high-level programming language. Used for rapid application development, as well as for use as a scripting or glue language to connect existing components together."
    },
    { 
      type: "Web UI libraries",
      image: ReactIcon,
      title: "React",
      description: "JavaScript library for building user interfaces. It was created and is currently maintained by the developers of Facebook, and is a the first choice of the majority of web developers."
    },
    { 
      type: "Project management platform",
      image: SGIcon,      
      title: "ShotGrid",
      description: "Autodesk ShotGrid is the leading studio management platform that can be easily integrated to studios of any size. It is a great out-of-the-box solution for studios and can be easily customized"
    },
    { 
      type: " Application Programming Interface",
      image: APIIcon,
      title: "Any API",
      description: "APIs are the backbone of how modern web technologies communicate with each other. Each time you use an app like Facebook, send an instant message, or check the weather on your phone, you're using an API!"
    },
    { 
      type: "Production Tools",          
      image:AutodeskIcon,
      title: "Autodesk Apps",
      description: "We have built integrated systems and custom tool sets for a wide range of Autodesk studio DCCs, including 3D Studio Max, Maya and MudBox and Shotgrid."
    },
    { 
      type: "eCommerce Platforms",      
      image:ECommerceIcon,
      title: "eCommerce",
      description: "We can work with eCommerce platforms such as Shopify, BigCommerce and others. Using existing templates to build simple, static shop-fronts or build custom 'headless' UIs using the platform's API "
    },
    { 
      type: "Many more ...",        
      image:PipelineIcon,
      title: "Business Tools",
      description: "We can work with any existing technology or platform and tailor them to fit your organisation's requirements. From dynamic workspace tools like Smartsheets to internal instant messagers like Mattermost."
    },    
    // { 
    //   title: "Javascript",
    //   description: "Lorem ipsum donor amet siti ceali ut enim ad minim veniam, quis nostrud."
    // },
  ];

  if (!cards) cards = defaultCards;

  return (
    <Container id="tech">
      <ThreeColumnContainer>
        {subheading && <Subheading>{subheading}</Subheading>}
        <Heading>{heading}</Heading>
        {description && <Description>{description}</Description>}
        <VerticalSpacer />
        {cards.map((card, i) => (
          <Column key={i}>
            <Card>
              <span className="textContainer">
                  <CardType>{card.type}</CardType>
                <img src={card.image || defaultCardImage} tw="items-center m-auto my-8" width={128} height={128} alt=""></img>
                <span className="title">{card.title || ""}</span>
                <p className="description">
                  {card.description || "Lorem ipsum donor amet siti ceali ut enim ad minim veniam, quis nostrud."}
                </p>
              </span>
            </Card>
          </Column>
        ))}
      </ThreeColumnContainer>
    </Container>
  );
};
